<template>
    <v-app>
        <top-nav />
        <div class="register_page">
            <div class="register_page_container">
                <user-exist
                    v-if="resultRegister && resultRegister.user_red != ''"
                    :name="userData.first_name"
                    :username="resultRegister.user_red"
                />
                <new-user
                    v-else
                    :userData="userData"
                    :resultRegister="resultRegister"
                />
            </div>
        </div>
        <footer-nav />
    </v-app>
</template>
<script>
import Topnav from '@/containers/navs/Topnav'
import UserExist from '@/containers/users/UserExist'
import NewUser from '@/containers/users/NewUser'
import Footer from '@/containers/navs/Footer'

import { mapGetters } from 'vuex'

export default {
    components: {
       "top-nav": Topnav,
       "footer-nav": Footer,
       "user-exist": UserExist,
       "new-user": NewUser,
    },
    data() {
        return {

        }
    },
    mounted() {
        if(this.resultRegister == null || this.userData == null){
            this.$router.push("/login");
        }

        // console.log(this.resultRegister);
        // console.log(this.userData);
    },
    computed: {
        ...mapGetters(['resultRegister','userData'])
    },
}
</script>
<style lang="scss">
@import '../assets/styles/layout/register';
</style>
